module.exports = __webpack_public_path__ + "assets/hardaccel.601de9b8.svg";